import { AuthCard, AuthCardFooter, AuthCardHeader } from "../AuthCard";

// // // //

type Variant = "login" | "register";

const variantToTitle: Record<Variant, string> = {
    login: "Sign in to your RWA.xyz account",
    register: "Create your RWA.xyz account",
};

const variantToDescription: Record<Variant, string> = {
    login: "We'll email you a one-time code. New users are set up automatically.",
    register:
        "Thank you for browsing RWA.xyz. Create an account or sign in to continue.",
};

// // // //

export function AuthFormCardSeparator() {
    return (
        <div className="flex items-center gap-3">
            <div className="h-px flex-1 bg-slate-200" />
            <span className="text-xs font-medium uppercase tracking-wide text-secondary-foreground">
                Or
            </span>
            <div className="h-px flex-1 bg-slate-200" />
        </div>
    );
}

export function AuthFormCard(props: {
    variant: Variant;
    children: React.ReactNode;
}) {
    const title = variantToTitle[props.variant];
    const description = variantToDescription[props.variant];

    return (
        <AuthCard>
            <AuthCardHeader title={title} description={description} />

            <div className="mt-5 sm:mt-8 space-y-4 sm:space-y-6">
                {props.children}

                <AuthCardFooter variant={props.variant} />
            </div>
        </AuthCard>
    );
}
